import state from "./ScaffoldState";
import { addData, getPage, removeById, removeData, getList, updateData, updateState } from "@/api/baseApi";
import { Message, MessageBox } from 'element-ui'
import {handleTree,setDateRange} from "@/utils/common";

/**
 * 脚手架定义表数据提供者
 *
 * @author PeterLee
 * @since 2026-06-04
 */
export default {
    namespaced: true,
    state: state,
    getters: {},
    mutations: {
        /** 设置表单弹窗显示 */
        setDialogVisible(state, visible) {
            state.formInfo.dialogVisible = visible;
        },
        /** 点击提交 */
        clickAdd(state) {
            state.formInfo.isAdd = true;
            state.formInfo.dialogVisible = true;
        },
        /** 点击编辑 */
        clickEdit(state, data) {
            state.formInfo.isAdd = false;
            state.formInfo.dialogVisible = true;
            state.formInfo.editData = data;
        },
    },
    actions: {
        /** 添加提交后执行内容 */
        submitAdd({commit, dispatch}, data) {
            addData("data", "scaffold", data).then(res => {
                if (res.code === 200) {
                    dispatch('handleTableSearch')
                    Message.success("添加脚手架成功")
                    commit('setDialogVisible', false)
                }
            });
        },
        /** 删除 */
        handleDel({dispatch}, data) {
            MessageBox.confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type:'warning'
            }).then(() => {
                removeById("data", "scaffold", data.id).then(res => {
                    if (res.code === 200) {
                        dispatch('handleTableSearch')
                        Message.success("删除成功！")
                    }
                })
            }).catch(() => {
                Message.info("已取消删除")
            });
        },
        /** 处理表格查询 */
        handleTableSearch({state}) {
            let param = state.queryParams;
            for (let key in state.dateRange) {
                param = setDateRange(param, state.dateRange[key], key);
            }
            getPage("data", "scaffold", param).then(res => {
                if (res.code === 200) {
                    state.tableData = res.data.list;
                    state.totalCount = res.data.totalCount;
                }
            })
        },
        /** 获取OptionList */
        getOptionList({state}) {
            getList("data", "templatePackage").then(res => {
                if (res.code === 200) {
                    state.options.templatePackageIdOptions = res.data;
                }
            })
        },
        /** 编辑提交后执行内容 */
        submitEdit({commit, dispatch}, data) {
            updateData("data", "scaffold", data).then(res => {
                if (res.code === 200) {
                    dispatch('handleTableSearch')
                    Message.success("修改脚手架信息成功")
                    commit('setDialogVisible', false)
                }
            });
        },
    },
    modules: {}
}
